import { Trash2 } from "lucide-react";
import React from "react";
import { Button } from "src/components/ui/button";
import { Dialog, DialogContent, DialogFooter,DialogHeader, DialogTitle } from "src/components/ui/dialog";

interface DeleteConversationDialogProps {
  isOpen: boolean;
  onClose: () => void;
  conversationTitle: string;
  onConfirm: () => void;
  isDeleting: boolean;
}

const DeleteConversationDialog: React.FC<DeleteConversationDialogProps> = ({
  isOpen,
  onClose,
  conversationTitle,
  onConfirm,
  isDeleting
}) => {
  React.useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === "Enter" && !isDeleting) {
        e.preventDefault();
        onConfirm();
      }
    };

    if (isOpen) {
      document.addEventListener("keydown", handleKeyDown);
    }

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [isOpen, isDeleting, onConfirm]);

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="bg-popover sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="flex items-center text-foreground">
            Delete Conversation
          </DialogTitle>
          <p className="text-muted-foreground mt-2 text-sm sm:text-base">
            Are you sure you want to delete the conversation <span className="font-semibold break-words">"{conversationTitle || "Untitled"}"</span>?
            <br />
            This action cannot be undone.
          </p>
        </DialogHeader>
        <DialogFooter className="mt-4 flex flex-col sm:flex-row gap-2 sm:gap-0">
          <Button
            variant="outline"
            onClick={onClose}
            disabled={isDeleting}
            className="w-full sm:w-auto sm:mr-2 order-2 sm:order-1"
          >
            Cancel
          </Button>
          <Button
            variant="destructive"
            onClick={onConfirm}
            disabled={isDeleting}
            loading={isDeleting}
            loadingText="Deleting..."
            className="w-full sm:w-auto bg-red-600 hover:bg-red-700 order-1 sm:order-2"
          >
            <Trash2 className="h-4 w-4 mr-2" />
            Delete
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default DeleteConversationDialog;